import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    logout();
  };

  const adminMenuItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
    { path: '/admin/tournaments', label: 'Tournaments', icon: '🏆' },
    { path: '/admin/players', label: 'Players', icon: '🏌️' },
    { path: '/admin/betting', label: 'Betting', icon: '💰' },
    { path: '/admin/transactions', label: 'Transactions', icon: '💳' },
    { path: '/admin/blocks', label: 'Blocks', icon: '📝' },
    { path: '/admin/analytics', label: 'Analytics', icon: '📊' },
    { path: '/admin/settings', label: 'Settings', icon: '⚙️' }
  ];

  return (
    <div className="admin-layout">
      {/* Admin Header */}
      <header className="admin-header">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <button 
              className="admin-sidebar-toggle"
              onClick={toggleSidebar}
            >
              ☰
            </button>
            <h1 className="admin-title">Admin Panel</h1>
          </div>
          
          <div className="admin-header-right">
            <span className="admin-user-info">
              Welcome, {user?.firstName} {user?.lastName}
            </span>
            <Link to="/dashboard" className="admin-btn admin-btn-secondary">
              Back to Dashboard
            </Link>
            <button onClick={handleLogout} className="admin-btn admin-btn-danger">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="admin-main">
        {/* Admin Sidebar */}
        <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <nav className="admin-nav">
            {adminMenuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-nav-item ${
                  location.pathname === item.path ? 'active' : ''
                }`}
              >
                <span className="admin-nav-icon">{item.icon}</span>
                <span className="admin-nav-label">{item.label}</span>
              </Link>
            ))}
          </nav>
        </aside>

        {/* Admin Content */}
        <main className="admin-content">
          <div className="admin-content-wrapper">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
